import { axios } from 'libs';
import saveAs from 'react-file-download';

const resource = '/arquivos';

export const download = ({ nome, identificador }) => {
  return axios
    .get(`${resource}/${identificador}/download`, {
      responseType: 'blob'
    })
    .then(response => {
      let fileName = nome;
      if (!fileName) {
        const headerContent = response.headers['content-disposition'];
        const searchName = headerContent.split('filename="')[1];
        fileName = searchName.replace('"', '');
      }
      return saveAs(
        new Blob([response.data], { type: response.data.type }),
        fileName
      );
    });
};

export const remove = (idProcesso, idArquivo) => {
  return axios.delete(`${resource}/${idArquivo}${idProcesso}`);
};

export const preview = (previewUrl, identificador) => {
  if (previewUrl) {
    window.open(previewUrl);
    return Promise.resolve();
  }

  const newWindow = window.open();

  return axios
    .get(`${resource}/${identificador}/download`, { responseType: 'blob' })
    .then(({ data }) => {
      newWindow.location = URL.createObjectURL(
        new Blob([data], { type: data.type })
      );
    });
};

export const rawDownload = identificador => {
  return axios.get(`${resource}/${identificador}/download`, {
    responseType: 'blob'
  });
};
